import imagesLoaded from 'imagesloaded';

/**
 * Add loaded class to loaded images
 */
const imgLoad = imagesLoaded(document.querySelector('body'), { background: true });

imgLoad.on('progress', function( instance, image ) {
  if ( image.isLoaded ) {
    image.img.classList.add('loaded');
  }
});

export default imgLoad;

